// extracted by mini-css-extract-plugin
export var bodySections = "_46-8";
export var gray = "_46-7";
export var green = "_46-4";
export var iconContainer = "_46-9";
export var iconWidgetContainer = "_46-1";
export var phoneIcon = "_46-2";
export var red = "_46-5";
export var statusDot = "_46-3";
export var widgetContainer = "_46-0";
export var yellow = "_46-6";